export const sportsKeyByName = {
    CRICKET: 4,
    SOCCER: 1,
    TENNIS: 2,
    BASKET_BALL: 7522,
    ELECTION: 2378962,
    KABADDI: 138
}